export const USER_SIGN_IN = "V3_USER_SIGN_IN";
export const USER_SIGN_OUT = "V3_USER_SIGN_OUT";
export const USER_PROFILE_UPDATE = 'V3_USER_PROFILE_UPDATE';
export const USER_PROFILE_CREATE = 'V3_USER_PROFILE_CREATE';
export const USER_PROFILE_PREFERENCE_UPDATE = 'V3_USER_PROFILE_PREFERENCE_UPDATE';
export const USER_ACCOUNT_PACKAGES_GET = 'V3_USER_ACCOUNT_PACKAGES_GET'
// export const CREATE_USER = 'V3_CREATE_USER'
// export const UPDATE_USER = 'V3_UPDATE_USER'